module.exports = __webpack_public_path__ + "static/img/icon_yiqiansdds.6ea93af6.png";